import { Icon } from "@iconify/react";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { OnBoarding } from "~/Components";
import { useQuery } from "~/Hooks/useQuery";
import { post } from "~/Services";
import { ReactComponent as PassLock } from "../../../Assets/SVG/lock.svg";
import { ReactComponent as MailIcon } from "../../../Assets/SVG/mail.svg";

const { Title, Text, Link } = Typography;

export const ResetPasswordPage = () => {
  const query = useQuery();
  const email = query.get("emailAddress");
  const verificationToken = query.get("verificationToken");

  const navigate = useNavigate();
  const validationSchema = Yup.object({
    emailAddress: Yup.string().email("Invalid email").required("Email is required"),
    token: Yup.string().required("Verification token is required"),
    newPassword: Yup.string().min(6, "Minimum 6 characters").required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords must match")
      .required("Confirm your password"),
  });

  const [confirmValues, setConfirmValues] = useState({});
  const handleSetPassword = () => {
    post("auth/reset-password", confirmValues, { "X-Auth-Type": "manual" })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <OnBoarding>
        <Row style={{ marginBottom: 25 }}>
          <Col span={24}>
            <Title level={2}>Reset Password</Title>
            <Text>Now create your password what ever you want</Text>
          </Col>
        </Row>
        <Formik
          initialValues={{
            emailAddress: email ?? "",
            passwordResetCode: verificationToken ?? "",
            newPassword: "",
            confirmNewPassword: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            // if (handleReset) handleReset(values);
          }}
        >
          {({ handleSubmit, handleChange, handleBlur, values, errors, touched }) => {
            setConfirmValues(values);
            return (
              <Form
                layout="vertical"
                onFinish={handleSubmit}
              >
                <Row style={{ marginBottom: "16px" }}>
                  <Col span={24}>
                    <Form.Item
                      label="Email"
                      validateStatus={touched.emailAddress && errors.emailAddress ? "error" : ""}
                      help={touched.emailAddress && errors.emailAddress}
                    >
                      <Input
                        name="emailAddress"
                        prefix={<MailIcon />}
                        size="large"
                        placeholder="Enter your email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col span={24}>
                    <Form.Item
                      label="Verification Token"
                      validateStatus={touched.passwordResetCode && errors.passwordResetCode ? "error" : ""}
                      help={touched.passwordResetCode && errors.passwordResetCode}
                    >
                      <Input
                        name="passwordResetCode"
                        size="large"
                        placeholder="Enter verification token"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.passwordResetCode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col span={24}>
                    <Form.Item
                      label="New Password"
                      validateStatus={touched.newPassword && errors.newPassword ? "error" : ""}
                      help={touched.newPassword && errors.newPassword}
                    >
                      <Input.Password
                        name="newPassword"
                        prefix={<PassLock />}
                        iconRender={(visible) =>
                          visible ? (
                            <Icon
                              icon="mdi:eye-outline"
                              width={18}
                              height={18}
                            />
                          ) : (
                            <Icon
                              icon="mdi:eye-off-outline"
                              width={18}
                              height={18}
                            />
                          )
                        }
                        size="large"
                        placeholder="Create your new password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.newPassword}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "16px" }}>
                  <Col span={24}>
                    <Form.Item
                      label="Confirm Password"
                      validateStatus={touched.confirmNewPassword && errors.confirmNewPassword ? "error" : ""}
                      help={touched.confirmNewPassword && errors.confirmNewPassword}
                    >
                      <Input.Password
                        name="confirmNewPassword"
                        prefix={<PassLock />}
                        iconRender={(visible) =>
                          visible ? (
                            <Icon
                              icon="mdi:eye-outline"
                              width={18}
                              height={18}
                            />
                          ) : (
                            <Icon
                              icon="mdi:eye-off-outline"
                              width={18}
                              height={18}
                            />
                          )
                        }
                        size="large"
                        placeholder="Confirm your new password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmNewPassword}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <Form.Item>
                      <Button
                        type="primary"
                        size="large"
                        block
                        htmlType="submit"
                        onClick={handleSetPassword}
                      >
                        Reset Password
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
        <div style={{ display: "flex", gap: 6, justifyContent: "center", marginTop: 16 }}>
          <Text>Remember your password. Return to</Text>
          <Link onClick={() => navigate("/auth/login")}>Login</Link>
        </div>
      </OnBoarding>
    </>
  );
};
